<div class="container_filter">
  <div class="header">
    <div class="title-description">
      <h2 class="filter-title">
        {{ "import.filter.title" | translate }}
      </h2>
      <p class="filter-description">
        {{ "filter.description" | translate }}
      </p>
    </div>
    <button class="close" (click)="close()">
      <img src="assets/icones/close.svg" alt="" />
    </button>
  </div>

  <div class="content">
    <div class="selection">
      <div class="import-and-selected">
        <ng-container *ngIf="importFilter?.filters?.length > 0">
          <button class="select-saved-filter" [matMenuTriggerFor]="menu">
            <img src="assets/icones/import-filter.svg" alt="" />
            <small>{{ "filter.import" | translate }}</small>
          </button>
          <mat-menu #menu="matMenu" class="import-menu">
            <div class="filter_btn" *ngFor="let filter of importFilter?.filters || []">
              <span (click)="setFilter(filter)">{{ filter.name }}</span>
              <button (click)="deleteFilter(filter)">
                <img src="assets/icones/delete_btn.svg" alt="">
              </button>
            </div>
          </mat-menu>
        </ng-container>
        <div class="applied-filters-count" (click)="clearFilters()">
          <span class="count">{{ getFiltersCount() }}</span>
          <span>{{ "filter.applied" | translate }}</span>
          <img src="assets/icones/clear-filter.svg" alt="" />
        </div>
      </div>
      <div class="filter-group">
        <div class="group-title" (click)="selectedGroup = 'import_info'">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "import.filter.groups." + selectedGroup| translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.importInfofilter.name">
            <span>
              {{ "import.filter.fields.name" | translate }} :
              {{ filter.importInfofilter.name }}
            </span>
            <img src="assets/icones/clear-filter.svg" alt="" (click)="filter.importInfofilter.name  = undefined" />
          </div>
          <div class="filter" *ngIf="filter.importInfofilter.status !== null && filter.importInfofilter.status !== undefined">
          <span>
            {{ "import.filter.fields.status" | translate }} :
            {{
              (   filter.importInfofilter.status === 'imported'
                ? "import.filter.values.imported"
                : "import.filter.values.draft"
              )
              | translate
            }}
          </span>
            <img src="assets/icones/clear-filter.svg" alt="" (click)="filter.importInfofilter.status = undefined" />
          </div>
          <div class="filter" *ngIf="
              filter.importInfofilter.start_date || filter.importInfofilter.end_date
            ">
            <span>
              {{
              "import.filter.fields.date" | translate
              }} :
              <ng-container *ngIf="filter.importInfofilter.start_date">
                {{ "common.from" | translate }}
                {{ filter.importInfofilter.start_date}}
              </ng-container>
              <ng-container *ngIf="filter.importInfofilter.end_date">
                {{ "common.to" | translate }}
                {{ filter.importInfofilter.end_date }}
              </ng-container>
            </span>
            <img src="assets/icones/clear-filter.svg" alt="" (click)="
                filter.importInfofilter.start_date = undefined;
                filter.importInfofilter.end_date = undefined
              " />
          </div>

          <div class="filter" *ngIf="
            filter.importInfofilter.nbr_products_min || filter.importInfofilter.nbr_products_max
          ">
            <span>
              {{
              "import.filter.fields.nbr_products" | translate
              }} :
              <ng-container *ngIf="filter.importInfofilter.nbr_products_min">
                {{ "common.from" | translate }}
                {{ filter.importInfofilter.nbr_products_min }}
              </ng-container>
              <ng-container *ngIf="filter.importInfofilter.nbr_products_max">
                {{ "common.to" | translate }}
                {{ filter.importInfofilter.nbr_products_max }}
              </ng-container>
            </span>
            <img src="assets/icones/clear-filter.svg" alt="" (click)="
              filter.importInfofilter.nbr_products_min = undefined;
              filter.importInfofilter.nbr_products_max = undefined
            " />
          </div>
        </div>
      </div>



    </div>
    <div class="form">
      <ng-container *ngIf="selectedGroup === 'import_info'">
        <div class="form-title">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "import.filter.groups." + selectedGroup | translate }}</h3>
        </div>

        <div class="inputs">
          <div class="field">
            <label for="name">{{
              "import.filter.fields.name" | translate
              }}</label>
            <input id="name" type="text" [(ngModel)]="filter.importInfofilter.name"
              [placeholder]="'import.filter.fields.name' | translate" />
          </div>
          <div class="field">
            <label for="">{{
              "import.filter.fields.status" | translate
              }}</label>
            <select [(ngModel)]="filter.importInfofilter.status">
              <option value="" disabled selected>
                {{ "import.filter.fields.status" | translate }}
              </option>
              <option [ngValue]="'draft'">
                {{ "import.filter.values.draft" | translate }}
              </option>
              <option [ngValue]="'imported'">
                {{ "import.filter.values.imported" | translate }}
              </option>
            </select>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="start_date">{{
                "import.filter.fields.start_date" | translate
                }}</label>
              <input id="start_date" type="datetime-local" [(ngModel)]="filter.importInfofilter.start_date"
                [placeholder]="'import.filter.fields.start_date' | translate" />
            </div>
            <div class="field">
              <label for="end_date">{{
                "import.filter.fields.end_date" | translate
                }}</label>
              <input id="end_date" type="datetime-local" [(ngModel)]="filter.importInfofilter.end_date"
                [placeholder]="'import.filter.fields.end_date' | translate" />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="nbr_products_min">{{
                "import.filter.fields.nbr_products_min" | translate
                }}</label>
              <input id="nbr_products_min" type="number" min="0" [max]="filter.importInfofilter.nbr_products_max || 1"
                [(ngModel)]="filter.importInfofilter.nbr_products_min" [placeholder]="
                    'import.filter.fields.nbr_products_min' | translate
                  " />
            </div>
            <div class="field">
              <label for="nbr_products_max">{{
                "import.filter.fields.nbr_products_max" | translate
                }}</label>
              <input id="nbr_products_max" type="number" [min]="filter.importInfofilter.nbr_products_min || 0"
                [(ngModel)]="filter.importInfofilter.nbr_products_max" [placeholder]="
                    'import.filter.fields.nbr_products_max' | translate
                  " />
            </div>
          </div>
        </div>

      </ng-container>

    </div>
  </div>

  <div class="footer submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
      <span>{{"common.cancel"|translate | uppercase}}</span>
      <img src="../../../../../assets/icones/arrow_back.svg" alt="">
    </button>
    <div class="save-apply">
      <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
        <div class="label-action">
          <label for="filter_name">{{
            'filter.filter_name'  | translate
            }}</label>
          <div class="actions">
            <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate }}</button>
            <button class="save-btn" (click)="save()">
              {{ "common.save" | translate | uppercase }}
            </button>
          </div>
        </div>
        <input id="filter_name" type="text" class="filter-name-input"
          [placeholder]="'filter.filter_name' | translate" [(ngModel)]="filterName"
          [formControl]="filterNameControl" />
          <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
            {{ "common.required_field" | translate }}
          </span>
      </div>
      <button class="save save_filter" [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm" (click)="toggleSaveFilter()">
        <img src="assets/icones/save-filter.svg" alt="" />
        <small>{{ "filter.save" | translate }}</small>
      </button>
      <button class="save_btn_pop_up blue_btn" (click)="apply()">
        <small>{{ "filter.apply" | translate | uppercase }}</small>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
</div>